export default {
  getList: '/v3/mapping/bd/train/client/core/taskList',
  // getList: '/train/client/core/taskList'
  // getList: '/v3/mapping/bd/train/client/core/taskList'
  siteList: '/v3/mapping/bd/train/client/site/siteList',
  booking: '/v3/mapping/bd/train/client/site/booking',
  timeSlotList: '/v3/mapping/bd/train/client/site/timeSlotList',
  taskDetail: '/v3/mapping/bd/train/client/core/taskDetail',
  waitTrain: '/v3/mapping/bd/train/client/site/waitTrain',
  resultBooking: '/v3/mapping/bd/train/client/site/resultBooking'
}
